module.exports = __webpack_public_path__ + "static/media/02C.25770733.png";